export default from './Loading';



// WEBPACK FOOTER //
// ./src/components/atoms/Loading/index.js